module.exports = __webpack_public_path__ + "static/referenceimage-238e8a09a6c665a436795eb376c669a1.mp4";